/** Figma: Button / Icon / Circle — 40px, white fill, no border, 20px icon; never disabled (infinite loop) */
export const EXCLUSIVE_CAROUSEL_NAV_BUTTON_CLASS =
	"static h-10 w-10 shrink-0 rounded-full border-0 bg-white p-0 text-gray-700 shadow-none hover:bg-gray-100 active:bg-gray-100";

export const EXCLUSIVE_CAROUSEL_NAV_ICON_CLASS = "h-5 w-5 text-gray-700";

/** Match listing exclusive slider: infinite scroll, arrows always active */
export const EXCLUSIVE_PDP_CAROUSEL_OPTS = {
	align: "start" as const,
	loop: true,
};

/** Horizontal inset for PDP exclusive header and scrollbar — cards bleed to the right edge */
export const EXCLUSIVE_PDP_CAROUSEL_INSET_CLASS = "px-4 md:px-10";

/** Reset default Carousel.Content (-ml-4) and Carousel.Item (pl-4) inset; align track with header and clip at container edges */
export const EXCLUSIVE_PDP_CAROUSEL_CONTENT_CLASS =
	"-ml-0 gap-2 pl-4 md:gap-3 md:pl-10";

export const EXCLUSIVE_PDP_CAROUSEL_ITEM_CLASS = "pl-0";
